import './dashboard.scss'
import { useContext, useEffect, useState } from 'react'
import { Outlet, useNavigate } from 'react-router-dom'
import AppInfoContext from 'src/provider/state-manager/appInfoProvider'
import { Header, Sidebar } from 'src/component'

export const DashboardRoutes = () => {
    const navigate = useNavigate()
    const {recoverStatesData} = useContext(AppInfoContext)
    const [token, setToken] = useState<string|null>(null)

    useEffect(() => {
        recoverStatesData()
        handleAuth()
    }, [])

    async function handleAuth () {
        let userToken = await localStorage.getItem('token')
        if (userToken) setToken(userToken)
        else navigate('/login')
    }
    
    return (
        <>
            {
                token ?
                    <div className="dashboard-container">
                        <Sidebar/>
                        <div className="dashboard-content">
                            <Header />
                            <div className='dashboard-modules'>
                                <Outlet/>
                            </div>
                        </div>
                    </div>
                    : null
            }
        </>
    )
}

export default {
    routeProps: {
        path: 'dashboard',
        element: <DashboardRoutes/>
    },
    name: 'Dashboard'
}